import { useEffect, useState } from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

export default function ApiDocsPage() {
  const [spec, setSpec] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/v1/docs')
      .then(r => {
        if (!r.ok) throw new Error('Ошибка загрузки спецификации');
        return r.json();
      })
      .then(data => { setSpec(data); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Загрузка документации API...</div>;
  if (error) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--color-danger)' }}>{error}</div>;

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Документация API</h2>
        <a href="/api/v1/docs" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm">
          Скачать OpenAPI JSON
        </a>
      </div>
      <div className="card">
        <div className="card-body" style={{ padding: 0 }}>
          {spec && (
            <div style={{ '--swagger-ui-font': 'Inter, system-ui, sans-serif' } as any}>
              <SwaggerUI
                spec={spec}
                deepLinking={true}
                docExpansion="list"
                defaultModelsExpandDepth={0}
                tryItOutEnabled={true}
                filter={true}
                requestSnippetsEnabled={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
